<!-- 主页 首页 -->
<template>
	<div class="mainPageBox">
		<div class="topBanner" v-if="bannerShow == 1">
			<el-carousel trigger="click" :interval="10000" :height="mainBannerHeight">
				<el-carousel-item v-for="item in bannerData" :key="item.objid">
					<video v-if="item.isMovie" class="bannerImg" preload="auto" loop autoplay muted>
						<source :src="item.imageAddress" :type="`video/${item.isMovie}`" />
					</video>
					<img v-else-if="!item.imageAddress" class="" src="@/assets/imgBackground/rectangle.png" />
					<img v-else class="bannerImg" :src="item.imageAddress" :alt="item.title" @click="outsideClick(item.link_address)" />
				</el-carousel-item>
			</el-carousel>
		</div>
		<div v-if="companyShow == 1" style="background: #f6f6f6">
			<div v-if="!phoneScreen" class="mainpageBox" style="display: flex; padding: 86px 0">
				<div class="leftText">
					<div class="blockTitle">关于我们</div>
					<div class="engText" style="color: #409eff">About us</div>
					<div class="blockContent">{{ aboutUsText }}</div>
					<div class="moreOurInfo" @click="insideClick('companyProfile')">查看详情</div>
				</div>
				<img class="aboutUsImg" v-if="aboutUsImg" :src="aboutUsImg" alt="" />
				<img class="aboutUsImg" v-else src="@/assets/imgBackground/rectangle.png" />
			</div>
			<div v-else class="phoneBlock">
				<div class="blockTitle" style="margin-top: 20px;">关于我们</div>
				<div class="engText">About us</div>
				<img class="" v-if="aboutUsImg" :src="aboutUsImg" alt="" />
				<img class="" v-else src="@/assets/imgBackground/rectangle.png" />
				<div class="blockContent">{{ aboutUsText }}</div>
				<el-button class="" plain @click="insideClick('companyProfile')">查看详情</el-button>
			</div>
		</div>
		<div v-if="companyShow == 1" style="background: #ffffff">
			<div :class="!phoneScreen ? 'mainpageBox' : 'phoneBlock'">
				<div class="blockTitle">公司动态</div>
				<div class="engText">Company Dynamics</div>
				<div class="trends">
					<el-card class="trendsCard" v-for="item in trendsData" :body-style="{ padding: '0px' }" shadow="hover" :key="item.objid">
						<div style="cursor: pointer; position: relative;" @click="insideClick('companyDynamicsDetails', item.objid)">
							<img class="trendsImg" v-if="item.imageAddress" :src="item.imageAddress" />
							<img class="trendsImg" v-else src="@/assets/imgBackground/square.png" />
							<div class="hoverIntro">
								<div style="margin: 60px 40px;">{{ item.content_abstract }}</div>
							</div>
							<img class="smallTrendsImg" :src="item.imageAddress" alt="">
							<div class="bottomTitle">
								<div class="trendsTime">{{ item.time }}</div>
								<div class="trendsTitle">{{ item.title }}</div>
							</div>
						</div>
					</el-card>
				</div>
				<div v-if="!phoneScreen" class="moreTrends" @click="insideClick('companyDynamics')">查看更多</div>
				<el-button v-else class="" plain @click="insideClick('companyDynamics')">查看更多</el-button>
			</div>
		</div>
		<div v-if="serviceShow == 1" style="background: #f6f6f6">
			<div v-if="!phoneScreen" class="mainpageBox">
				<div class="blockTitle">产品服务</div>
				<div class="engText">Product Service</div>
				<div class="" style="line-height: 30px">{{ productInformation }}</div>
				<el-button class="moreProduct" plain @click="insideClick('productServices')">查看更多</el-button>
				<div class="productTable" v-if="productList.length > 0">
					<div class="tableLeft">
						<div v-for="(item, index) in currentProductList" :key="index" :class="index === 1 ? 'activceItem' : ''" class="productItem" @click="productClick(item)">
							<div class="productName">{{ item.product_name }}</div>
							<div class="productInfo">{{ item.title }}</div>
							<div class="xuhao">{{ '0' + item.serial_number }}</div>
						</div>
					</div>
					<div class="tableRight">
						<div class="productCarousel">
							<el-carousel ref="productCarousel" trigger="click" :interval="10000" type="card" height="200px" @change="productChange">
								<el-carousel-item v-for="item in productList" :key="item.objid">
									<img class="" v-if="item.imageAddress" style="width: 100%;" :src="item.imageAddress" :alt="item.product_name" @click="productClick(item)" />
									<img class="" v-else src="@/assets/imgBackground/rectangle.png" />
								</el-carousel-item>
							</el-carousel>
						</div>
						<div class="productIntroduce">{{ productIntroduction }}</div>
					</div>
					<img class="worldMap" src="@/assets/world_map.png" alt="" />
				</div>
			</div>
			<div v-else class="phoneBlock">
				<div class="blockTitle">产品服务</div>
				<div class="engText">Product Service</div>
				<el-carousel :interval="5000" height="53vw" @change="productChange">
					<el-carousel-item v-for="item in productList" :key="item.objid">
						<img class="" v-if="item.imageAddress" :src="item.imageAddress" :alt="item.product_name" @click="productClick(item)" />
						<img class="" v-else src="@/assets/imgBackground/rectangle.png" />
					</el-carousel-item>
				</el-carousel>
				<div style="font-size: 18px; margin: 10px 0;">{{ productName }}</div>
				<div style="line-height: 26px; margin-bottom: 20px;">{{ productIntroduction }}</div>
				<el-button class="" plain @click="insideClick('productServices')">查看更多</el-button>
			</div>
		</div>
		<div v-if="partnerShow == 1" style="background: #ffffff">
			<div :class="!phoneScreen ? 'mainpageBox' : 'phoneBlock'">
				<div class="blockTitle">合作伙伴</div>
				<div class="engText">Cooperative partner</div>
				<div class="friends">
					<div class="friendsItem" v-for="item in partnerData" :key="item.objid">
						<div class="friendsLogo" @click="outsideClick(item.link_address)">
							<img class="" :src="item.imageAddress" :alt="item.title" />
						</div>
						<div class="friendsName">{{ item.title }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { formatTime } from '@/utils/tools';

export default {
	name: 'product-introduction',
	data() {
		return {
			bannerShow: 1,
			serviceShow: 1,
			partnerShow: 1,
			companyShow: 1,
			bannerData: [],
			aboutUsText: '',
			aboutUsImg: '',
			trendsData: [],
			productInformation: '',
			activceItem: 0,
			productList: [],
			currentProductList: [],
			productName: '',
			productIntroduction: '',
			partnerData: [],

			boxSizeWidth: '',
			phoneScreen: false,
			mainBannerHeight: '900px',
		};
	},
	created() {
		this.getMainPageConfig();

		this.mainBannerHeight = '46vw';
		// if (document.body.clientWidth < 1200) {
		// 	this.mainBannerHeight = document.body.clientWidth * 0.46 + 'px';
		// } else if (document.body.clientWidth < 1400) {
		// 	// 1366
		// 	this.mainBannerHeight = '640px';
		// } else if (document.body.clientWidth < 1500) {
		// 	// 1440
		// 	this.mainBannerHeight = '675px';
		// } else if (document.body.clientWidth < 2000) {
		// 	// 1920
		// 	this.mainBannerHeight = '900px';
		// } else {
		// 	// 2560
		// 	this.mainBannerHeight = '1200px';
		// }

		if (document.body.clientWidth < 1200) {
			this.boxSizeWidth = 'width: calc(100% - 60px);';
			this.phoneScreen = true;
		} else {
			this.boxSizeWidth = 'width: 1200px;';
			this.phoneScreen = false;
		}
	},
	mounted() {
		this.getBanner();
		this.getOurIntroduce();
		this.getEnterpriseTrends();
		this.getProductIntroduce();
		this.getProductList();
		this.getPartnerList();
		if (!this.phoneScreen) setTimeout(() => {
			this.$refs.productCarousel.setActiveItem(1);
		}, 800);
	},
	methods: {
		// 获取首页配置项
		getMainPageConfig() {
			this.$API.getNavbar({ refgrp: 'OW_NAVI_BAR' }, (res) => {
				let navbarList = res;
				navbarList.forEach((item) => {
					if (item.navi_cd === 'CAROUSEL_PICTURES') this.bannerShow = item.is_enabled;
					if (item.navi_cd === 'PRODUCT_SERVICE_COPYWRITING') this.serviceShow = item.is_enabled;
					if (item.navi_cd === 'PARTNER') this.partnerShow = item.is_enabled;
					if (item.navi_cd === 'COMPANY_INFO') this.companyShow = item.is_enabled;
				});
			});
		},
		// 页面初始化诸方法
		getBanner() {
			this.$API.getBannerPicture({}, (res) => {
				this.bannerData = res.list;
				for (let item of this.bannerData) {
					// item.imageAddress = process.env.BASE_API + 'mp-file/file/' + item.master_image_address;

					let fileType = item.images[0].image_address.split('.')[1];
					if (fileType === 'mp4' || fileType === 'avi' || fileType === 'flv' || fileType === 'mov') {
						item.isMovie = fileType;
						item.imageAddress = process.env.BASE_API + 'mp-file/file/' + item.images[0].image_address;
					} else {
						this.$API.getSmallFile({ fileName: item.images[0].image_address, format: 'webp', Q: 50 }, (res) => {
							let blob = new Blob([res], {type: 'webp'});
							let url = window.URL.createObjectURL(blob);
							this.$set(item, 'imageAddress', url);
						});
					}
				}
			});
		},
		getOurIntroduce() {
			this.$API.getCompanyProfileList({}, (res) => {
				this.aboutUsText = res.title;
				this.aboutUsImg = null;

				this.$API.getSmallFile({ fileName: res.images[0].image_address, format: 'webp', Q: 60 }, (res) => {
					let blob = new Blob([res], {type: 'webp'});
					let url = window.URL.createObjectURL(blob);
					this.aboutUsImg = url;
				});
			});
		},
		getEnterpriseTrends() {
			let sendData = { pageNum: 1, pageSize: 3, topped_status: 0, };
			this.$API.findCompanyDynamicByClientList(sendData, (res) => {
				this.trendsData = res.list;
				for (let item of this.trendsData) {
					// item.imageAddress = process.env.BASE_API + 'mp-file/file/' + item.master_image_address;
					this.$API.getSmallFile({ fileName: item.master_image_address, format: 'webp', }, (res) => {
						let blob = new Blob([res], {type: 'webp'});
						let url = window.URL.createObjectURL(blob);
						this.$set(item, 'imageAddress', url);
					});
					item.time = formatTime(item.created_at).split(' ')[0];
				}
			});
		},
		getProductIntroduce() {
			this.$API.getProductIntroduce({}, (res) => {
				if (res.list.length > 0) this.productInformation = res.list[0].content;
			});
		},
		getProductList() {
			let sendData = { pageNum: 1, pageSize: 10 };
			this.$API.getProductList(sendData, (res) => {
				this.productList = res.list;
				for (let item of this.productList) {
					// item.imageAddress = process.env.BASE_API + 'mp-file/file/' + item.master_image_address;
					this.$API.getSmallFile({ fileName: item.affiliated_image_address, format: 'webp', }, (res) => {
						let blob = new Blob([res], {type: 'webp'});
						let url = window.URL.createObjectURL(blob);
						this.$set(item, 'imageAddress', url);
					});
				}
				this.currentProductList = this.productList.slice(0, 3);
				this.productName = this.currentProductList[1].product_name;
				this.productIntroduction = this.currentProductList[1].introduction;
			});
		},
		getPartnerList() {
			this.$API.getPartnerList({}, (res) => {
				this.partnerData = res.list;
				for (let item of this.partnerData) {
					// item.imageAddress = process.env.BASE_API + 'mp-file/file/' + item.images[0].image_address;
					this.$API.getSmallFile({ fileName: item.images[0].image_address, format: 'webp', }, (res) => {
						let blob = new Blob([res], {type: 'webp'});
						let url = window.URL.createObjectURL(blob);
						this.$set(item, 'imageAddress', url);
					});
				}
			});
		},


		// 外链点击
		outsideClick(link) {
			if (!link) return;
			window.open(link, '_blank');
		},
		// 内链点击
		insideClick(name, objid = null) {
			if (!name) return;
			if (!objid) this.$router.push({ name: name });
			else this.$router.push({ name: name, query: { objid: objid } });
		},

		// 产品服务轮播图change
		productChange(index) {
			let arr = [];
			if (this.productList[index - 1]) arr.push(this.productList[index - 1]);
			else arr.push(this.productList[this.productList.length - 1]);
			arr.push(this.productList[index]);
			if (this.productList[index + 1]) arr.push(this.productList[index + 1]);
			else arr.push(this.productList[0]);
			this.currentProductList = arr;
			this.productName = this.currentProductList[1].product_name;
			this.productIntroduction = this.currentProductList[1].introduction;
		},
		// 产品服务左侧滚动条跳转
		productClick(data) {
			if (data.link_address) this.outsideClick(data.link_address);
			else this.$router.push({ name: 'productIntroduction', query: { objid: data.objid } });
		},
	},
};
</script>

<style scoped>
.bannerImg {
	width: 100%;
	height: 100%;
	object-fit: fill;
}
.mainpageBox {
	width: 1200px;
	margin: auto;
	padding: 56px 0;
}

/* 关于我们 */
.leftText {
	width: 300px;
	height: 420px;
	margin-right: 80px;
	text-align: left;
	position: relative;
}
.blockTitle {
	font-size: 24px;
	color: #363636;
}
.engText {
	margin: 10px 0 24px;
	color: #999999;
}
.blockContent {
	white-space: pre-wrap;
	line-height: 30px;
	max-height: 280px;
}
.moreOurInfo {
	color: #409eff;
	cursor: pointer;
	position: absolute;
	right: 20px;
	bottom: 20px;
}
.aboutUsImg {
	width: 810px;
	height: 420px;
}
/* 公司动态 */
.trends {
	display: flex;
	padding: 70px 0;
	height: 425px;
	align-items: flex-start;
}
.trendsCard {
	margin-right: 100px;
}
.trendsCard:last-of-type {
	margin-right: 0;
}
.trendsImg {
	width: 330px;
	height: 330px;
	object-fit: cover;
}
.hoverIntro {
	position: absolute;
	background-color: #176FFF;
	color: #F6F6F6;
	text-align: left;
	line-height: 30px;
	overflow: hidden;
	box-sizing: border-box;
	transition-duration: 0.5s;
	transition: .5s;
	top: 330px;
	height: 0;
}
.smallTrendsImg {
	position: absolute;
	top: 330px;
	left: 165px;
	border-radius: 50%;
	width: 0;
	height: 0;
	transition-duration: 0.5s;
	transition: .5s;
	object-fit: cover;
}
.bottomTitle {
	height: 50px;
	padding: 20px;
	width: 290px;
	transition-duration: margin 0.5s;
	transition: margin .5s;
}
.trendsCard:hover .hoverIntro {
	top: 0;
	height: 330px;
}
.trendsCard:hover .smallTrendsImg {
	left: 120px;
	top: 285px;
	width: 90px;
	height: 90px;
}
.trendsCard:hover .bottomTitle {
	margin-top: 40px;
}
.trendsTime {
	font-size: 18px;
	color: #4c4c4c;
	line-height: 20px;
	margin-bottom: 10px;
}
.trendsTitle {
	color: #999999;
	line-height: 16px;
}
.moreTrends:hover {
	color: #409eff;
}
.moreTrends {
	color: #999999;
	cursor: pointer;
}
/* 产品服务 */
.moreProduct {
	margin-top: 60px;
	color: #999999;
}
.productTable {
	display: flex;
	position: relative;
	padding: 80px 0 100px;
}
.tableLeft {
	width: 500px;
	height: 450px;
	margin-right: 70px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.tableLeft,
.tableRight {
	z-index: 10;
}
.productItem {
	width: 460px;
	height: 50px;
	padding: 50px 20px;
	position: relative;
	cursor: pointer;
	text-align: left;
	line-height: 28px;
	background-color: #ffffff;
	color: #999999;
}
.productName {
	font-size: 18px;
	color: #4c4c4c;
}
.xuhao {
	position: absolute;
	font-size: 62px;
	line-height: 62px;
	color: #c6e2ff;
	font-weight: bold;
	right: 20px;
	bottom: 40px;
}
.activceItem.productItem {
	background-color: #186fff;
	color: #ffffff;
}
.activceItem.productItem .productName {
	color: #ffffff;
}
.activceItem.productItem .xuhao {
	color: #ffffff;
	font-size: 100px;
	line-height: 100px;
	bottom: 10px;
}
.productCarousel {
	margin: 32px 0;
}
.productIntroduce {
	width: 500px;
	height: 80px;
	padding: 30px 60px;
	background-color: #ffffff;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	line-height: 26px;
}
.worldMap {
	position: absolute;
	bottom: -50px;
	right: -200px;
}
/* 合作伙伴 */
.friends {
	display: flex;
	flex-wrap: wrap;
	padding: 100px 0 0;
}
.friendsLogo {
	width: 164px;
	height: 60px;
	border: 1px solid #d6d6d6;
	margin: 0 10px;
	padding: 10px;
	cursor: pointer;
}
.friendsLogo img {
	width: 50px;
	height: 50px;
}
.friendsName {
	line-height: 50px;
}



.phoneBlock {
	background-color: #ffffff;
	width: 100%;
	padding: 16px;
	box-sizing: border-box;
	text-align: left;
}
.phoneBlock .blockTitle {
	display: inline-block;
}
.phoneBlock .engText {
	display: inline-block;
	margin-left: 10px;
}
.phoneBlock img { width: -webkit-fill-available; }
.phoneBlock .blockContent {
	line-height: 20px;
	margin: 15px 0;
}
.phoneBlock .trends {
	display: block;
	height: auto;
	padding: 0;
}
.phoneBlock .trendsCard {
	/* max-width: 330px; */
	margin: auto;
	margin-bottom: 25px;
}
.phoneBlock .trendsCard .trendsImg {
	height: 93vw;
	/* aspect-ratio: 1/1; */
}
.phoneBlock .friends {
	padding: 0;
	text-align: center;
}
.phoneBlock .friendsLogo {
	width: 108px;
	height: 48px;
}
.phoneBlock .friends img {
	width: 48px;
	height: 48px;
}
</style>



// WEBPACK FOOTER //
// src/applyPages/mainPage.vue